/**
 * Point webpack async chunks at the same origin/base as the parent bundle.
 * Prefer the real script URL (fixes BrowserSync :3000 vs artisan :8041).
 * Fall back to Blade-provided path (staging /public normalization).
 */
export function applyWebpackPublicPath() {
    if (typeof document === "undefined") {
        return;
    }

    let base = null;
    const scripts = document.getElementsByTagName("script");
    for (let i = scripts.length - 1; i >= 0; i -= 1) {
        const src = scripts[i].src || "";
        if (/\/js\/(landing|app)\.js(\?|#|$)/.test(src)) {
            base = src.replace(/\/js\/[^/?#]+(?:\?.*)?(?:#.*)?$/, "/");
            break;
        }
    }

    if (!base && typeof window !== "undefined" && window.__CLARITICK_JS_PATH__) {
        base = window.__CLARITICK_JS_PATH__;
    }

    if (!base) {
        base = "/";
    }

    // eslint-disable-next-line camelcase, no-undef
    __webpack_public_path__ = base;
}
